import * as React from "react";

const IconRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#4F4FFF"
      fillRule="evenodd"
      d="M5.152 3.151a1.2 1.2 0 0 1 1.697 0l4 4a1.2 1.2 0 0 1 0 1.697l-4 4a1.2 1.2 0 1 1-1.697-1.697L8.304 8 5.152 4.848a1.2 1.2 0 0 1 0-1.697Z"
      clipRule="evenodd"
    />
  </svg>
);
export default IconRight;
